import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useEndpoint } from '@apparatix/composables';
import {
  HalFeature,
  HalFeatures,
  HalConfig,
  HalConfigs,
  type HalFeaturesResponse,
} from '@apparatix/types/HalOptions';

export const useHalFeatures = defineStore('hal-options', () => {
  const features = ref<HalFeatures>({} as HalFeatures);
  const configs = ref<HalConfigs>({} as HalConfigs);
  const loaded = ref(false);

  useEndpoint<HalFeaturesResponse>({
    type: 'GET',
    url: '/hal-features',
    successField: 'data',
    toast: {
      showOnError: false,
      showOnSuccess: false,
    },
    onSuccess: ({ data }) => {
      if (!data) return;
      features.value = data.features;
      configs.value = data.configs;
      loaded.value = true;
    },
  }).makeRequest();

  const hasFeature = (feature: HalFeature) => features.value[feature];

  const hasConfig = (config: HalConfig) => configs.value[config];

  /**
   * Do not use this in production code, this is only intended to provide developers a way to manually toggle features for testing purposes
   */
  // eslint-disable-next-line camelcase
  const __unsafe_dev_toggle_feature = (feature: HalFeature, enabled: boolean) => features.value[feature] = enabled;

  return {
    hasConfig,
    hasFeature,
    // eslint-disable-next-line camelcase
    __unsafe_dev_toggle_feature,
  };
});
